import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import '../index.css';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../images/1.jpg';
import '../../images/2.jpg';
import '../../images/3.jpg';
import '../../images/4.jpg';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';
import { Slide as SlideDetails } from 'material-auto-rotating-carousel';
import { AutoRotatingCarousel } from 'material-auto-rotating-carousel';
import {Button} from "@material-ui/core";
import {red} from "@material-ui/core/colors";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AnnouncementIcon from '@material-ui/icons/Announcement';


type newsProps = {
  newsItem: any;
};

const itemPath = '../images/news/';


function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(require.context('../../images/news', false, /\.(png|jpe?g|svg)$/));


@observer
export default class NewsPage extends React.Component<newsProps> {
  state = {
    isOpen: false,
    photoIndex: 0,
    open: false,
    currentItem: {
      type: false,
      imgAlign: "",
      items: [],
      images: [],
      text: "",
      header: "",
      mainImage : "",
      furtherInfo: false
    }
  };

  openModal = (headerText) => {
    const item = this.props.newsItem.getNewsItem(headerText);
    this.setState({
      open: true,
      isOpen: false,
      currentItem : item
    });
  };

  loadImages = () => {
    this.setState({ isOpen: true });
  };

  hideModal = () => {
    this.setState({
      open: false,
      isOpen : false
    });
  };

  render() {

    return (
      <div>
        <div>
          <Slide easing="ease">
            <div className="each-slide">
              <div className="image_newsPage" style={{'backgroundImage': `url("./images/1.jpg")`}}>
              </div>
            </div>
            <div className="each-slide">
              <div className="image_newsPage" style={{'backgroundImage': `url("./images/2.jpg")`}}>
              </div>
            </div>
            <div className="each-slide">
              <div style={{'backgroundImage': `url("./images/3.jpg")`}}>
              </div>
            </div>
            <div className="each-slide">
              <div style={{'backgroundImage': `url("./images/4.jpg")`}}>
              </div>
            </div>
          </Slide>
        </div>
        <div className="newsContainer">
          <section className="blog-cat mt-5 pb-5">
            <Modal
              show={this.state.open}
              onHide={this.hideModal}
              aria-labelledby="ModalHeader"
              centered={true}
              className={this.state.currentItem.type ? "offerClass" :  "newsClass" }
            >
              <Modal.Header closeButton>
                <Modal.Title id="ModalHeader">
                  {this.state.currentItem.header}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ position: 'relative', width: '100%', height: "auto", overflow: "hidden" }}>
                  {this.state.currentItem.type ?
                      <div>
                            <div className="wrapperModalContent wrapperModalTraktor">
                              <div className="divLeft">
                                <img className="imageModal" src={itemPath + this.state.currentItem.mainImage} alt={"Mehele Landtechnik"} />
                              </div>
                              <div className="divRightModal">
                                <h1>
                                  {this.state.currentItem.header}
                                </h1>
                                <ul className="listParent">
                                  {this.state.currentItem.items.map((e) => (
                                      <li className={e.bold ? "listModal boldPrint" : "listModal"}>{e.text}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          <div className="information_text_modal">
                              Bei Interesse oder für weitere Informationen kontaktieren Sie uns per <Link to="/Kontakt">Kontaktformular</Link> oder <Link to="/Team">telefonisch</Link>.
                          </div>

                      </div>
                        :
                      <div className={this.state.currentItem.imgAlign == "auto" ? "alignCenter" : ""}>
                        <img className={this.state.currentItem.imgAlign == "auto" ? "autoImageWidth" : "mainImageModal"} src={itemPath + this.state.currentItem.mainImage} alt={"Mehele Landtechnik"} />
                        {this.state.currentItem.items.map((e) => (
                        <div className={e.bold ? "paragraphModal centerparagraph" : "paragraphModal"}>
                              {e.text}
                            </div>
                        ))}
                      </div>}
                  {
                    this.state.currentItem.furtherInfo == true ?
                        <div className="information_text_modal">
                          Bei Interesse oder für weitere Informationen kontaktieren Sie uns per <a href="mailto:rainer.mehele@mehele.at">Mail</a> oder <Link to="/Team">telefonisch</Link>.
                        </div>
                        :
                        null
                  }
                  {this.state.currentItem.images.length > 1 ? <Button className="buttonImages" onClick={() => this.loadImages()}><CameraAltIcon/>Weitere Bilder</Button> : ""}
                  <div className="sliderPopUp">
                    {this.state.isOpen && (
                        <Lightbox
                            mainSrc={itemPath + this.state.currentItem.images[this.state.photoIndex]}
                            nextSrc={itemPath + images[(this.state.photoIndex + 1) % images.length]}
                            prevSrc={itemPath + images[(this.state.photoIndex + this.state.currentItem.images.length - 1) % this.state.currentItem.images.length]}
                            onCloseRequest={() => this.setState({ isOpen: false })}
                            onMovePrevRequest={() =>
                                this.setState({
                                  photoIndex: (this.state.photoIndex + this.state.currentItem.images.length - 1) % this.state.currentItem.images.length,
                                })
                            }
                            onMoveNextRequest={() =>
                                this.setState({
                                  photoIndex: (this.state.photoIndex + 1) %  this.state.currentItem.images.length,
                                })
                            }
                        />
                    )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-primary" onClick={this.hideModal}>
                  schliessen
                </button>
              </Modal.Footer>
            </Modal>
            {this.props.newsItem.newsList.map((element) => (
                <div className="fullbar-item w-100 cursor-pointer" onClick={() => this.openModal(element.header)}>
                  <div className="container">
                    <div className="row py-3 py-md-5 align-items-center border-top">
                      <div className="col-md-10">
                        {element.type ? <div><AddShoppingCartIcon />AKTION</div> : <div><AnnouncementIcon />NEWS</div>}
                        <h3 className="feed-item-heading m-0 font-weight-800">
                          <a className="text-black">
                            {element.header}
                          </a>
                        </h3>
                        <p className="m-0 text-pink text-uppercase">
                          {element.date}
                        </p>
                      </div>
                      <div className="col-md-2">
                        <div>
                          <img className="imageNews" src={itemPath + element.mainImage}  alt={"Mehele Landtechnik"}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            ))}
          </section>
        </div>
      </div>
    );
  }
}
